import { Table } from "antd";
import { DocumentTableIcon } from "@/shared/assets/svg/icons";
import "@/entities/journal";

export const RenderExpandedRow = () => {
  const subData = [
    { key: "1", page: "01", list: "|", stamp: "Штамп" },
    { key: "2", page: "02", list: "|", stamp: "Штамп" },
    { key: "3", page: "03", list: "|", stamp: "Штамп" },
  ];

  const subColumns = [
    {
      title: "Страница",
      dataIndex: "page",
      key: "page",
      render: (text: string) => (
        <span className="journal-expanded-doc-link">
          <DocumentTableIcon style={{ marginRight: 4 }} />
          {text}
        </span>
      ),
    },
    {
      title: "Лист",
      dataIndex: "list",
      key: "list",
    },
    {
      title: "Штамп",
      dataIndex: "stamp",
      key: "stamp",
    },
  ];

  return (
    <div className="expanded-documents-list-container">
      <div className="expanded-documents-list">
        <Table
          columns={subColumns}
          dataSource={subData}
          pagination={false}
          size="small"
          showHeader
        />
        <div className="journal-expanded-doc-edit-link">
          Редактировать
        </div>
      </div>
    </div>
  );
};

